import React from "react";
import Pirinc from "../Components/urunlerimiz/Pirinc";
import PageHeader from "../Components/common/PageHeader";
import { useTranslation } from "react-i18next";
import TopBar from "../Components/common/TopBar";
import Spacer4 from "../Components/common/Spacer4";
import useSEO from "../seo/useSEO";

function PirincPage() {
  const { t } = useTranslation();

  useSEO({
    title: "Özel Üretim Pirinç Parça İmalatı | Aypin Otomat",
    description:
      "Aypin Otomat özel üretim pirinç parça çözümleri ve CNC kayar otomat ile hassas talaşlı imalat hizmetleri hakkında bilgi alın.",
    path: "/pirinc",

    breadcrumbs: [
      {
        name: "Ana Sayfa",
        path: "/",
      },
      {
        name: "Ürünlerimiz",
        path: "/urunlerimiz",
      },
      {
        name: "Özel Üretim Pirinç Parçalar",
        path: "/pirinc",
      },
    ],
  });

  return (
    <>
      <TopBar />
      <Spacer4 />

      <PageHeader
        title={t("Özel Üretim Pirinç Parçalar")}
      />

      <Pirinc />
    </>
  );
}

export default PirincPage;